import React from 'react';
import { Layout } from 'antd';
import CommonHeader from "../components/commonHeader";
import { Outlet } from "react-router-dom";
import { RouterAuth } from "../router/routerAuth";
import styles from './main.module.css'

const { Content } = Layout;

const Main = () => {
    return (
        <RouterAuth>
            <Layout className={styles.container}>
                <CommonHeader />
                <Content className={styles.content}>
                    <Outlet />
                </Content>
            </Layout>
        </RouterAuth>
    );
}

export default Main;

